import React from 'react';

const AdBanner = ({ onClose, adData }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        borderRadius: '15px',
        padding: '20px',
        maxWidth: '350px',
        width: '90%',
        textAlign: 'center',
        position: 'relative'
      }}>
        {/* Real Ad Content */}
        <div style={{
          background: 'linear-gradient(90deg, #00E9FF, #8A2BE2)',
          borderRadius: '10px',
          padding: '30px',
          marginBottom: '15px'
        }}>
          <h3 style={{ color: 'white', margin: '0 0 10px 0' }}>
            {adData?.title || 'Advertisement'}
          </h3>
          <p style={{ color: 'white', margin: 0, fontSize: '14px' }}>
            {adData?.content || 'Ad content'}
          </p>
        </div>
        
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            color: 'white',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Continue Swiping
        </button>
      </div>
    </div>
  );
};

export default AdBanner;